export default __webpack_public_path__ + "static/media/enable.cb2a6524.svg";